import React, {ReactNode} from "react"

type PageContentProps = {
    children?: ReactNode
    footer?: boolean
    overflow?: boolean
}

const PageContent: React.FC<PageContentProps> = ({footer, children, overflow}) => {
    return (
        <div
            className={`${footer ? "h-[calc(100vh-3.5rem)]" : "h-screen"} ${overflow ? "overflow-y-auto" : "overflow-hidden no-scrollbar"} p-4 -m-1`}
        >
            {children}
        </div>
    )
}

export default PageContent
